import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'sbnb-search-field',
  templateUrl: './search-field.component.html',
  styleUrls: ['./search-field.component.scss'],
})
export class SearchFieldComponent implements OnInit {
  @Input() value: string;
  @Input() placeholder: string = 'Ask us something';
  @Input() autofocus: boolean = false;
  @Input() debounceTimeMs: number = 400;
  @Output() valueChange = new EventEmitter();
  @ViewChild('input') input;

  private valueChangeSubject: Subject<string> = new Subject();

  constructor() { }

  ngOnInit(): void {
    this.valueChangeSubject.pipe(debounceTime(this.debounceTimeMs)).subscribe((newValue: string) => {
      this.value = newValue;
      this.valueChange.emit(newValue);
    });
  }

  ngAfterViewInit(): void {
    if (this.autofocus) {
      this.input.nativeElement.focus();
    }
  }

  change(newValue) {
    this.valueChangeSubject.next(newValue);
  }
}
